import { GlobalPassThrough } from 'primeng/config';

export const nonResizableDialogPassThrough: GlobalPassThrough = {
  dialog: { resizeHandle: { style: { display: 'none' } } },
};
